export default "e0420f780d3d7156.svg"